<template>
  <div>
    <bo-user-list title="Utilisateurs"
                  subtitle="Back Office"
                  storePrefix="bouser"
                  routePrefix="users"
                  :keepLast="true"
                  :parentAll="all"></bo-user-list>
  </div>
</template>

<script>
import boUserList from '@/components/bouserlist'
import { mapState } from 'vuex'

export default {
  name: 'admin-list',

  computed: mapState({
    all: state => state.bouser.all
  }),

  created () {
    this.$store.dispatch('bouser/all')
  },

  components: {
    'bo-user-list': boUserList
  }
}
</script>

<style scoped lang="less">
</style>
